import jQuery, { dequeue } from 'jquery'
import 'foundation-sites/js/entries/foundation'
import LazyLoad from 'vanilla-lazyload'
import {} from './vendors/splidejs'
import { CommonListeners } from './CommonListeners'

window.jQuery = window.$ = jQuery

import './lang-select'

// Load Events
jQuery(document).ready(($) => {

    let myLazyLoad = new LazyLoad({
        elements_selector: '.lazyload',
    })
    myLazyLoad.update()

    const waitToShow = $('.waitToShow')
    if (waitToShow.length) $(waitToShow).removeClass('waitToShow')

    $(document).foundation()

    CommonListeners();
})
